import React, { useMemo, useState } from "react";

import { useTranslation } from "../../../../hooks";
import { Icons } from "../../../../enums";
import { T } from "../../../../constants";
import { Checkbox } from "../checkbox";
import { Button } from "../button";
import { Modal } from "../modal";
import { Icon } from "../icon";

interface DialogModalProps {
  icon: Icons;
  text?: string;
  title?: string;
  infoTxt?: string;
  onClose: () => void;
  cancelText?: string;
  description?: string;
  iconColorHex: string;
  confirmText?: string;
  onConfirm: () => void;
  buttonLoading?: boolean;
  checkboxLabel?: string;
  closeOnOutsideClick?: boolean;
}

export const DialogModal: React.FC<DialogModalProps> = ({
  text,
  icon,
  onClose,
  onConfirm,
  title = "",
  infoTxt = "",
  description,
  iconColorHex,
  buttonLoading,
  checkboxLabel = "",
  closeOnOutsideClick,
  cancelText = T.CANCEL,
  confirmText = T.CONFIRM,
}) => {

  const t = useTranslation();

  const [confirmCheckbox, setConfirmCheckbox] = useState(false);

  const saveDisabled = useMemo(() => !!checkboxLabel && !confirmCheckbox, [checkboxLabel, confirmCheckbox]);

  return (
    <Modal
      title={title}
      onClose={onClose}
      closeOnOutsideClick={closeOnOutsideClick}
    >
      <div className="small-popup-container">
        <div className="small-popup-inner">
          <Icon wrap size="lg" type={icon} colorHex={iconColorHex} />
          <div className="attention-main-text">
            <p className="head-text">{text}</p>
            {description && <p className="small-pp-main-text">{description}</p>}
          </div>
          {
            infoTxt && (
              <div className="info-alert-container">
                <p className="info-alert-txt">
                  {t(infoTxt)}
                </p>
              </div>
            )
          }
          {
            checkboxLabel && (
              <div className="modal-checkbox-wrapper">
                <div className="checkbox-holder">
                  <div className="checkbox-label">
                    <Checkbox
                      label={t(checkboxLabel)}
                      checked={confirmCheckbox}
                      onChange={(e) => setConfirmCheckbox(e.target.checked)}
                    />
                  </div>
                </div>
              </div>
            )
          }
          <div className="popup-button-case-edit-balance">
            <div className="button-inner-case">
              <Button
                onClick={onClose}
                text={t(cancelText)}
                appearance="secondary"
              />
            </div>
            <div className="button-inner-case">
              <Button
                onClick={onConfirm}
                text={t(confirmText)}
                buttonLoading={buttonLoading}
                disabled={saveDisabled}
              />
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};
